<template>
  <div>
    <div>
      <el-form :inline="true" :model="listQuery" class="demo-form-inline">
        <el-form-item label="考试名称:">
          <el-select v-model="listQuery.exam_id" clearable placeholder="请选择" @change="getStudent">
            <el-option
              v-for="item in examList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="考生:">
          <el-select v-model="listQuery.student_id" clearable placeholder="请选择">
            <el-option
              v-for="item in studentList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" size="medium" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 折线图 -->
    <div class="chart" id="chart">

    </div>
    <div>
      <el-table :data="tableData" stripe style="width: 100%">
        <el-table-column label="序号">
          <template slot-scope="scope">
            {{scope.$index+1}}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="科目">
        </el-table-column>
        <el-table-column prop="mins" label="考试限时">
          <template slot-scope="scope">
            {{scope.row.mins}}分钟
          </template>
        </el-table-column>
        <el-table-column prop="timeAvg" label="平均耗时">
        </el-table-column>
        <el-table-column prop="scoreAvg" label="平均成绩">
        </el-table-column>
        <el-table-column prop="time" label="用时">
        </el-table-column>
        <el-table-column prop="score" label="成绩">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <i class="el-icon-search" @click="handleEdit(scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>

    </div>
  </div>
</template>

<script>
    export default {
        data() {
            return {
                studentList: [],
                examList: [],
                avgdata:[],
                subjectStr:[],
                studentScoreStr:[],
                scoreAvgStr:[],
                subStr:[],
                listQuery: {
                    page: 1,
                    per_page: 20
                },
                tableData: []
            };
        },
        computed: {},
        created() {
        },
        mounted() {
            this.getDataInit();
            window.addEventListener('resize', () => {
                this.$echarts.init(document.getElementById('chart')).resize()
            })

        },
        methods: {
            getStudent(value) {
                this.$http.getStudentByExamId({exam_id: value}).then(res => {
                    this.studentList = res.data.data;
                })
            },
            search() {
                this.listQuery.page = 1;
                this.getData()
            },
            // 获取全部的课程列表
            getDataInit() {
                this.$http.getStudentAnalysis()
                    .then(res => {
                        this.examList = res.data.examlist;
                        this.studentList = res.data.studentList;
                        this.listQuery.exam_id=res.data.exam_id;
                        this.listQuery.student_id=res.data.student_id;
                        this.getData();
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },

            getData() {
                this.$http.getStudentAnalysis(this.listQuery)
                    .then(res => {
                        this.tableData = res.data.data.list;
                            var singledata = res.data.data.singledata;
                            var scoreAvg = res.data.data.avgdata;
                            for(var i in singledata){
                                this.subjectStr.push(singledata[i].name);
                            }
                            for(var i in scoreAvg)
                            {
                                if(scoreAvg[i].name){
                                    this.subStr.push({
                                        text: scoreAvg[i].name,
                                        max: scoreAvg[i].score
                                    });
                                }else {
                                    this.subStr.push({
                                        text: scoreAvg[i].paper_name,
                                        max: scoreAvg[i].score
                                    });
                                }
                                if(singledata[i]){
                                    this.studentScoreStr.push(Number(singledata[i]['score']));
                                }
                                this.scoreAvgStr.push(Number(scoreAvg[i]['scoreAvg']));
                            }
                         this.getline()
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            handleEdit(scope) {
                    this.$router.push({name:'scoreResult',query:{id:scope.result_id}})
            },
            //构建图标
            getline() {
                let chart = this.$echarts.init(document.getElementById('chart'))
                // 绘制图表
                chart.setOption({
                    tooltip: {
                        trigger: "axis"
                    },
                    legend: {
                        orient: "vertical",
                        x: "right",
                        y: "bottom",
                        data: ["考生成绩", "平均分"]
                    },
                    polar: [{
                        indicator: this.subStr
                    }],
                    calculable: false,
                    series: [{
                        name: "考生成绩 vs 平均分",
                        type: "radar",
                        data: [{
                            value: this.studentScoreStr,
                            name: "考生成绩"
                        },
                            {
                                value: this.scoreAvgStr,
                                name: "平均分"
                            }]
                    }]
                });
            }
        },
    };
</script>

<style scoped lang="less">

  .chart {
    width: 100%;
    height: 300px;
    margin-right: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/page/statisticsManage/studentAnalysis.vue